import { View } from './view'

export const AppSection = View
